const { getConfig } = require("@cirrus/config")
const imgProcConfig = require("@cirrus/legacy/app-common/images/img-proc-config")

const getURL = function (relativeUrl, baseUrl) {
  if (!relativeUrl && !baseUrl) return ""
  if (relativeUrl.indexOf("~") > -1) relativeUrl = relativeUrl.replace("~", "")
  const base = window.location.protocol + "//" + window.location.host

  return base.concat(baseUrl || getConfig().BaseUrl, relativeUrl)
}

const getAuthorURL = function (relativeUrl) {
  if (!relativeUrl) return ""
  if (relativeUrl.indexOf("~") > -1) relativeUrl = relativeUrl.replace("~", "")
  const base = window.location.protocol + "//" + window.location.host

  return base.concat("/", relativeUrl)
}

const getApiURL = function (relativeUrl) {
  if (!relativeUrl) return ""
  if (relativeUrl.indexOf("~") > -1) relativeUrl = relativeUrl.replace("~", "")
  const base = getConfig().ApiHost

  return base.concat(relativeUrl)
}

const getSignalrUrl = function (relativeUrl) {
  if (!relativeUrl) return ""
  if (relativeUrl.indexOf("~") > -1) relativeUrl = relativeUrl.replace("~", "")
  const base = getConfig().SignalrHost

  return base.concat(relativeUrl)
}

const getDeliveryApiURL = function (relativeUrl) {
  if (App.isPreview) {
    return getApiURL("/api/v1/delivery/preview" + relativeUrl)
  } else if (App.isAnonymous) {
    return getApiURL("/api/v1/delivery/anonymous" + relativeUrl)
  } else {
    return getApiURL("/api/v1/delivery" + relativeUrl)
  }
}

const getProctoringApiURL = function (relativeUrl) {
  return getApiURL("/api/v1/proctoring" + relativeUrl)
}

const getSamlApiURL = function (relativeUrl) {
  if (!relativeUrl) return ""
  if (relativeUrl.indexOf("~") > -1) relativeUrl = relativeUrl.replace("~", "")
  const base = getConfig().SamlApiHost

  return base.concat(relativeUrl)
}

const getUrlWithToken = function (relativeUrl, options) {
  // because file download by link, need set access_token in url
  let template = "{url}"
  const params = options || {}

  params["access_token"] = sessionStorage.getItem(getConfig().TokenKey)
  template += "?{opts}".replace("{opts}", $.param(params))
  return template.replace("{url}", getApiURL(relativeUrl))
}

const getImageResizeUrl = function (url, options) {
  if (!url) return url // parse options, exs: { w: 100, h: 100 }, '?w=100&h=100', 'introAvatar'. last from imgProcConfig

  let parsedOptions = ""

  if (typeof options == "string") {
    if (options.indexOf("?") == 0) parsedOptions = options
    else if (imgProcConfig[options]) parsedOptions = $.param(imgProcConfig[options])
  } else if (options) {
    parsedOptions = $.param(options)
  }

  let template = "{url}"

  if (parsedOptions) {
    template += "?{opts}".replace("{opts}", parsedOptions)
  }

  return template.replace("{url}", url)
} // TODO: this is work around for exam results, this logic must to be in server

const getImageUrl = function (url) {
  const template = "{host}/{url}"
  const absoluteUrl = template.replace("{host}", getConfig().ImageHost).replace("{url}", url)

  return absoluteUrl
}

const getAnonymousSharingUrl = function (token) {
  const relativePath = "delivery/anonymous-login?session=" + token

  return getAuthorURL(relativePath)
}

const Url = {
  api: getApiURL,
  anonymousSharing: getAnonymousSharingUrl,
  author: getAuthorURL,
  deliveryApi: getDeliveryApiURL,
  get: getURL,
  img: getImageUrl,
  realtime: getSignalrUrl,
  resize: getImageResizeUrl,
  proctoringApi: getProctoringApiURL,
  samlapi: getSamlApiURL,
  token: getUrlWithToken,
}

module.exports = Url
